export default "https://cdn-static.gokick.com/assets/9c92702f75f0b67707db9d869eecabb5f21facb9/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";